module.exports = __webpack_public_path__ + "media/gundula4.f0b0131e.mp3";